// extracted by mini-css-extract-plugin
export var alt = "badge-module--alt--f0d46";
export var location = "badge-module--location--c09fd";
export var venueBadge = "badge-module--venue-badge--f002b";